export default {
  common: {
    welcome: 'Welcome',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    username: 'Username',
    nickname: 'Nickname',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    submit: 'Submit',
    cancel: 'Cancel',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    required: 'Required',
    optional: 'Optional',
    back: 'Back',
    next: 'Next',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    reset: 'Reset',
    actions: 'Actions',
    copyright: '© 2025 SpatialWalk. All Rights Reserved.',
    openPlatform: 'Open Platform',
    adminPlatform: 'Admin Platform',
    welcomeToOpenPlatform: 'Welcome to SpatialWalk Open Platform Admin',
    redirecting: 'Redirecting...',
    console: 'Console',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
  },
}
